import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AppStateService } from '../../../../core/services/quiz/app-state.service';
import { UserService } from '../../../../core/services/quiz/user.service';

@Component({
  selector: 'app-quiz-nav',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './quiz-nav.component.html',
  styleUrls: ['./quiz-nav.component.scss']
})
export class QuizNavComponent implements OnInit, OnDestroy {
  tickets = 0;
  ticketFlashing = false;
  selectedQuizId: string | null = null;

  navLinks = [
    { label: 'Intro', path: '/quiz' },
    { label: 'Arena', path: '/quiz/dashboard' },
    { label: 'Play', path: '/quiz/play' },
    { label: 'Leaderboard', path: '/quiz/leaderboard' },
    { label: 'Vault', path: '/quiz/vault' }
  ];

  directorName = '';

  private destroy$ = new Subject<void>();

  constructor(
    private state: AppStateService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.state.user$
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user) {
          this.tickets = user.tickets;
          if (user.display_name && user.display_name !== 'Guest Cinephile') {
            this.directorName = user.display_name;
          }
        }
      });

    this.state.selectedQuizId$
      .pipe(takeUntil(this.destroy$))
      .subscribe((quizId) => {
        this.selectedQuizId = quizId;
      });

    this.state.ticketFlash$
      .pipe(takeUntil(this.destroy$))
      .subscribe((amount) => {
        if (amount > 0) {
          this.ticketFlashing = true;
          setTimeout(() => (this.ticketFlashing = false), 1500);
        }
      });

    this.userService.loadCurrentUser().pipe(takeUntil(this.destroy$)).subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  navQueryParams(path: string): Record<string, string> | null {
    if (path === '/quiz/play' && this.selectedQuizId) {
      return { quizId: this.selectedQuizId };
    }

    return null;
  }
}
